import { RawFileModel } from "../models/raw-file-model";

export function guessMimeType(name: string): string {
  const ext = name.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'pdf':
      return 'application/pdf';
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'txt':
      return 'text/plain';
    default:
      return 'application/octet-stream';
  }
}

export function rawToDataBase64Url(raw: RawFileModel): string {
  if (raw.dataBase64) return `data:${guessMimeType(raw.name)};base64,${raw.dataBase64}`;
  if (raw.data) return `data:${guessMimeType(raw.name)};base64,${btoa(raw.data)}`;
  return '';
}